import { NgModule } from '@angular/core';
import { BreadcrumbsModule } from './breadcrumbs/breadcrumbs.module';

@NgModule({
    exports: [BreadcrumbsModule],
})
export class DirectivesModule {}
